import * as React from 'react';
import { CancelServiceOrderPayload as Payload } from 'contracts/service-orders';
import { api, handleApiError } from 'services/api';

export const useCancelServiceOrder = () => {
  const cancelOrder = React.useCallback(async (payload: Payload) => {
    try {
      const url = `inventory/service-orders/cancel-order/${payload.serviceOrderId}`;
      await api.put(url, payload.data);
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return { cancelOrder };
};